package com.kinoshazam.update.data

import com.kinoshazam.model.AppUpdate
import com.kinoshazam.model.Features
import com.kinoshazam.model.ServerResult
import io.ktor.client.HttpClient
import io.ktor.client.call.body
import io.ktor.client.request.get

class UpdateRepository(
    private val downloadManager: DownloadManager,
    private val httpClient: HttpClient,
) {

    suspend fun getAppUpdate(): AppUpdate? {
        val response = httpClient.get(urlString = "info/update").body<ServerResult<AppUpdate?>>()

        return response.result
    }

    suspend fun getAvailableFeatures(): Features? {
        val response = httpClient.get(urlString = "info/features").body<ServerResult<Features?>>()

        return response.result
    }

    suspend fun downloadUpdate() {
        downloadManager.downloadUpdate()
    }
}
